/**
 * Laukiama kliento — accountant→client questions/requests (internal-only for
 * now: answers arrive by any channel and are recorded here; the client portal
 * will answer in-app later).
 */
import { api } from './client';

export type ClientRequestKind = 'Question' | 'MissingDocument' | 'Approval';
export type ClientRequestStatus = 'Open' | 'Answered' | 'Cancelled';

export interface ClientRequestDto {
  id: number;
  kind: ClientRequestKind;
  status: ClientRequestStatus;
  text: string;
  scannedDocumentId: number | null;
  journalEntryId: number | null;
  askedBy: string;
  createdAtUtc: string;
  dueDate: string | null;
  answer: string | null;
  answeredBy: string | null;
  answeredAtUtc: string | null;
}

export const clientRequestsApi = {
  list: (status?: 'Open' | 'Answered' | 'Cancelled') =>
    api.get<ClientRequestDto[]>('/client-requests', status ? { status } : undefined),

  create: (request: {
    kind: ClientRequestKind;
    text: string;
    scannedDocumentId?: number | null;
    journalEntryId?: number | null;
    dueDate?: string | null;
  }) => api.post<ClientRequestDto>('/client-requests', request),

  answer: (id: number, answer: string) =>
    api.post<ClientRequestDto>(`/client-requests/${id}/answer`, { answer }),

  cancel: (id: number) => api.post<ClientRequestDto>(`/client-requests/${id}/cancel`),
};
